module.exports = __webpack_public_path__ + "static/media/operational3.08443219.png";